import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
    openCount: 0,
    pendingCount: 0
}

const setOpenCount = (state, action) => {
    return updateObject(state, { openCount: action.payload.openCount })
}

const setPendingCount = (state, action) => {
    return updateObject(state, { pendingCount: action.payload.pendingCount })
}


const CountReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_COUNTOPEN:
            return setOpenCount(state, action);
        case actionTypes.SET_COUNTPENDING:
            return setPendingCount(state, action);
        default:
            return state
    }
}

export default CountReducer;
